import * as antIcons from '@ant-design/icons-vue'
import '@/styles/base.less'
import '@/styles/default.less'
import '@/styles/vars.less'
// 把iota的icon也放这里
import '@iota-cn/util-icon/dist/css/iota_icons.css'
import '@iota-cn/ui-components/dist/iota-ui-components.css'

import 'ant-design-vue/es/message/style/css'
import { instanceCachingFactory, registry, singleton } from 'tsyringe'
import type { App } from 'vue'
import { CORE_INITIALIZER } from '../CoreSymbol'
import type { Initializer } from './Initializer'


/**
 *
 */
@singleton()
@registry([{
  token: CORE_INITIALIZER,
  useFactory: instanceCachingFactory<Initializer>(c => c.resolve(AntdInitializer))
}])
export class AntdInitializer implements Initializer {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  // constructor() {
  // }

  start(app: App<Element>): void {
    app.config.globalProperties.$antIcons = antIcons
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const allIcons = antIcons as any
    for (const key in allIcons) {
      app.component(key, allIcons[key])
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  started(app: App<Element>): void {
    // return
  }
}
